import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// Figma "Banner": the Tag surfaces (grey, yellow, blue, green), Body2 copy, and a 16px icon in the
// matching tag text color.
export const styles = (theme: Theme) => {
	return ({
		root: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
			padding: theme.spacing(2),
			borderRadius: 4,
			marginBottom: theme.spacing(2),
			color: theme.palette.custom.textPrimary,
		},
		neutral: {
			backgroundColor: theme.palette.custom.tagNeutralSurface,
		},
		warning: {
			backgroundColor: theme.palette.custom.tagWarningSurface,
		},
		info: {
			backgroundColor: theme.palette.custom.tagInfoSurface,
		},
		success: {
			backgroundColor: theme.palette.custom.tagSuccessSurface,
		},
		message: {
			display: "flex",
			alignItems: "flex-start",
			gap: theme.spacing(1),
			flex: "1 0 0",
			minWidth: 0,
		},
		icon: {
			display: "inline-flex",
			paddingTop: 4,
			flexShrink: 0,
		},
		neutralIcon: {
			color: theme.palette.custom.tagNeutralText,
		},
		warningIcon: {
			color: theme.palette.custom.tagWarningText,
		},
		infoIcon: {
			color: theme.palette.custom.tagInfoText,
		},
		successIcon: {
			color: theme.palette.custom.tagSuccessText,
		},
		body: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(0.5),
			flex: "1 0 0",
			minWidth: 0,
		},
		title: {
			fontSize: 16,
			fontWeight: "bold",
			lineHeight: "24px",
		},
		text: {
			fontSize: 16,
			lineHeight: "24px",
		},
		action: {
			flexShrink: 0,
		},
		dismiss: {
			padding: 0,
			color: theme.palette.custom.textSecondary,
		},
	} satisfies Record<string, CSSObject>);
};
